module.exports = __webpack_public_path__ + "static/media/esus_white.28764475.svg";